import React, { useEffect, useState } from "react";
import axios from "axios";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Button, Modal, Badge } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  BiCheck,
  BiChevronRight,
  BiCoinStack,
  BiShieldQuarter,
  BiInfoCircle,
  BiCheckCircle,
  BiMoviePlay,
  BiTimer,
} from "react-icons/bi";
import { ClipLoader } from "react-spinners";
import bgImage from "../../../../../../../Assets/images/matching-plt-header-bg.png";

export default function PackvideoDetails() {
  const { id } = useParams();
  const [packvideo, setPackvideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLoginMessage, setShowLoginMessage] = useState(false);

  const handleClose = () => setShowLoginMessage(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_APIURL}/public/packvideo/${id}`)
      .then((response) => {
        setPackvideo(response.data.result);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching pack video details:", error);
        setLoading(false);
      });
  }, [id]);

  const handleClickCommander = () => {
    setLoading(true);
    const token = localStorage.getItem("access_token_story");
    if (!token) {
      setShowLoginMessage(true);
      setLoading(false);
      return;
    }

    const data = {
      itemToBuyId: id,
      itemToBuyType: "PACK_VIDEO",
      token: token,
    };

    axios
      .post(
        `${process.env.REACT_APP_BILLING_URL}/create-checkout-session`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        },
      )
      .then((response) => {
        setLoading(false);
        window.open(response.data.url, "_blank");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error during checkout:", error);
      });
  };

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center bg-white">
        <ClipLoader color="#4AAE9B" size={50} />
      </div>
    );
  }

  if (!packvideo)
    return <div className="text-center py-5">Pack vidéo non trouvé.</div>;

  const features = packvideo.description
    .split(/[\r\n\.]/)
    .map((point) => point.trim())
    .filter((point) => point.length > 0);

  return (
    <section
      className="py-5 min-vh-100"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}>
      <MDBContainer style={{ paddingTop: "40px", paddingBottom: "40px" }}>
        <MDBRow className="justify-content-center">
          <MDBCol lg="10" xl="9">
            {/* 💡 BANNIÈRE INFO HAUTE */}
            <div className="text-center mb-5">
              <div
                className="d-inline-flex align-items-center p-2 pe-4 bg-white shadow-sm"
                style={{ borderRadius: "100px", border: "1px solid #E0F2F1" }}>
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#4AAE9B",
                  }}>
                  <BiTimer color="white" size={20} />
                </div>
                <span className="small fw-bold text-secondary">
                  Rechargez vos jetons pour débloquer et regarder nos vidéos
                  exclusives dès maintenant
                </span>
              </div>
            </div>

            <MDBRow className="g-5 align-items-stretch">
              {/* --- GAUCHE : VISUEL GLASS CARD --- */}
              <MDBCol lg="5">
                <div className="mb-4 text-center text-lg-start">
                  <h6
                    className="text-uppercase fw-bold mb-2"
                    style={{
                      color: "#4AAE9B",
                      letterSpacing: "2px",
                      fontSize: "0.75rem",
                    }}>
                    Boutique de jetons
                  </h6>
                  <h1
                    className="fw-bold display-5 mb-4"
                    style={{ color: "#1A3A36", letterSpacing: "-1px" }}>
                    {packvideo.name}
                  </h1>
                </div>

                <div
                  className="p-5 shadow-lg d-flex flex-column align-items-center justify-content-center position-relative overflow-hidden bg-white"
                  style={{
                    borderRadius: "40px",
                    background:
                      "linear-gradient(135deg, #ffffff 0%, #f0fdfa 100%)",
                    minHeight: "400px",
                    border: "1px solid #ffffff",
                  }}>
                  {/* Effet visuel de fond */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-10%",
                      right: "-10%",
                      width: "150px",
                      height: "150px",
                      background:
                        "radial-gradient(circle, rgba(74, 174, 155, 0.1) 0%, rgba(255,255,255,0) 70%)",
                      borderRadius: "50%",
                    }}></div>

                  <div
                    className="text-center position-relative"
                    style={{ zIndex: 2 }}>
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-4 bg-white"
                      style={{
                        width: "110px",
                        height: "110px",
                        borderRadius: "30px",
                        boxShadow: "0 15px 35px rgba(74, 174, 155, 0.15)",
                      }}>
                      <BiCoinStack size={50} style={{ color: "#4AAE9B" }} />
                    </div>

                    <h2
                      className="display-1 fw-bold mb-0"
                      style={{
                        color: "#1A3A36",
                        fontWeight: "900",
                        lineHeight: "1",
                      }}>
                      {packvideo.token_amount}
                    </h2>
                    <p
                      className="fw-bold text-uppercase mt-2 mb-0"
                      style={{
                        color: "#4AAE9B",
                        letterSpacing: "1px",
                        fontSize: "0.75rem",
                        maxWidth: "200px",
                        margin: "0 auto",
                      }}>
                      Jetons pour débloquer vos vidéos exclusives
                    </p>
                  </div>

                  <div
                    className="mt-5 px-3 py-2 rounded-4 fw-bold text-center"
                    style={{
                      backgroundColor: "rgba(74, 174, 155, 0.08)",
                      color: "#4AAE9B",
                      fontSize: "0.7rem",
                      lineHeight: "1.4",
                      maxWidth: "280px",
                    }}>
                    DÉBLOQUEZ LES VIDÉOS EXCLUSIVES DE NOS INTERVENANTS GRÂCE À
                    VOS JETONS
                  </div>
                </div>
              </MDBCol>

              {/* --- DROITE : DÉTAILS ET PAIEMENT --- */}
              <MDBCol lg="7">
                <div
                  className="p-4 p-md-5 h-100 shadow-lg bg-white d-flex flex-column"
                  style={{ borderRadius: "40px", border: "1px solid #E0F2F1" }}>
                  <div className="d-flex align-items-center mb-4">
                    <div
                      className="p-2 rounded-3 me-3"
                      style={{ backgroundColor: "#F0F9FF" }}>
                      <BiMoviePlay size={24} color="#4AAE9B" />
                    </div>
                    <h5 className="fw-bold mb-0 text-dark">
                      Informations du pack
                    </h5>
                  </div>

                  <div className="flex-grow-1 mb-5">
                    {features.map((item, i) => (
                      <div key={i} className="d-flex align-items-start mb-3">
                        <BiCheckCircle
                          className="me-2 mt-1 text-success"
                          size={20}
                        />
                        <span className="text-secondary fw-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  <div className="mt-auto pt-4 border-top">
                    <div className="d-flex justify-content-between align-items-end mb-4">
                      <div>
                        <p className="text-muted small mb-0">Total TTC</p>
                        <h2
                          className="display-4 fw-bold mb-0"
                          style={{ color: "#1A3A36" }}>
                          {packvideo.price}€
                        </h2>
                      </div>
                      <Badge
                        bg="light"
                        className="text-dark border px-3 py-2 rounded-pill small fw-medium">
                        Paiement unique
                      </Badge>
                    </div>

                    <Button
                      onClick={handleClickCommander}
                      className="w-100 py-3 shadow-none border-0 d-flex justify-content-between align-items-center px-4 mb-3"
                      style={{
                        backgroundColor: "#1A3A36",
                        borderRadius: "18px",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        transition: "all 0.3s ease",
                      }}>
                      Acheter ce pack <BiChevronRight size={28} />
                    </Button>

                    <div className="text-center mt-4">
                      <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
                        <BiShieldQuarter className="text-success" size={18} />
                        <span className="small fw-bold text-dark">
                          Paiement 100% sécurisé via Stripe
                        </span>
                      </div>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "0.7rem" }}>
                        Vos jetons seront crédités sur votre compte
                        immédiatement après l'achat.
                      </p>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <Modal show={showLoginMessage} onHide={handleClose} centered borderless>
        <Modal.Body
          className="p-5 text-center shadow-lg"
          style={{ borderRadius: "30px" }}>
          <div
            className="mb-4 d-inline-flex p-3 rounded-circle"
            style={{ backgroundColor: "#F0FDF4" }}>
            <BiInfoCircle size={40} style={{ color: "#4AAE9B" }} />
          </div>
          <h4 className="fw-bold mb-3">Connexion requise</h4>
          <p className="text-muted mb-4">
            Veuillez vous connecter pour acheter des jetons et accéder à vos
            vidéos exclusives.
          </p>
          <div className="d-grid gap-2">
            <Link
              to="/login"
              className="btn btn-primary py-3 border-0 fw-bold"
              style={{ backgroundColor: "#4AAE9B", borderRadius: "14px" }}>
              Continuer vers la connexion
            </Link>
            <Button
              variant="link"
              className="text-muted text-decoration-none mt-2"
              onClick={handleClose}>
              Plus tard
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}
